import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVerticalIcon, PackageIcon, PencilIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton, SplitItemIcon } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ProductsCardMenu = ({
  onPrepareParcel,
  onSplitParcel,
  allowPrepareParcel,
  allowAmendPackingStatus,
  allowSplitParcel,
  isInbound,
}) => {
  const { t } = useTranslation()

  const options = [
    {
      label: (
        <Styles.TitleOptionMenu>
          <PackageIcon />
          {t('Preparar envío')}
        </Styles.TitleOptionMenu>
      ),
      visible: allowPrepareParcel,
      onClick: onPrepareParcel,
    },
    {
      label: (
        <Styles.TitleOptionMenu>
          <SplitItemIcon size={20} />
          {t('Partir envío')}
        </Styles.TitleOptionMenu>
      ),
      visible: allowSplitParcel,
      onClick: onSplitParcel,
    },
    {
      label: (
        <Styles.TitleOptionMenu>
          <PencilIcon weight="thin" />
          {t('Corregir estado de empaquetado')}
        </Styles.TitleOptionMenu>
      ),
      visible: allowAmendPackingStatus,
      onClick: onPrepareParcel,
    },
  ].filter(option => option.visible)

  if (!options?.length || isInbound) return null

  return (
    <ButtonMenu
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon data-testid="menuButton" size={24} />}
        />
      )}
      menuItems={options}
    />
  )
}

export default ProductsCardMenu
